// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emptimelinepage-inline-1 {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
}

.emptimelinepage-inline-2 {
  font-size: 32px;
  margin-bottom: 8px;
}

.emptimelinepage-dyn-1 {
  color: var(--emptimelinepage-1-color);
  font-size: var(--emptimelinepage-1-font-size);
}

.emptimelinepage-dyn-2 {
  background: var(--emptimelinepage-2-background);
  border: var(--emptimelinepage-2-border);
}

.emptimelinepage-dyn-3 {
  width: 9px;
  height: 9px;
  border-radius: 5px;
  background: var(--emptimelinepage-3-background);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpTimelinePage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+CAA+C;AACjD","sourcesContent":[".emptimelinepage-inline-1 {\n  text-align: center;\n  padding: 40px;\n  color: #94a3b8;\n}\n\n.emptimelinepage-inline-2 {\n  font-size: 32px;\n  margin-bottom: 8px;\n}\n\n.emptimelinepage-dyn-1 {\n  color: var(--emptimelinepage-1-color);\n  font-size: var(--emptimelinepage-1-font-size);\n}\n\n.emptimelinepage-dyn-2 {\n  background: var(--emptimelinepage-2-background);\n  border: var(--emptimelinepage-2-border);\n}\n\n.emptimelinepage-dyn-3 {\n  width: 9px;\n  height: 9px;\n  border-radius: 5px;\n  background: var(--emptimelinepage-3-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
